import React from "react";
import "./SaveTheWavesBanner.css";

import SaveTheWaves from "../../images/save_the_waves.png";
import { Link } from "react-router-dom";

export const SaveTheWavesBanner = () => {
  return (
    <div className="save-the-waves-container">
      <Link to="https://www.savethewaves.org/puertoescondido/" target="_blank">
        <img
          className="save-the-waves-img"
          src={SaveTheWaves}
          alt="Save the waves puerto escondido"
        />
      </Link>
    </div>
  );
};
